import React, { useState, useEffect } from "react"
import { Router } from "@reach/router"
import Airtable from "airtable"
import "./styles/App.scss"
// Pages
import Login from "./pages/Login"
import Home from "./pages/Home"
import MyProfile from "./pages/MyProfile"
import Profile from "./pages/Profile"
import Compliance from "./pages/Compliance"
import NonCompliance from "./pages/NonCompliance"
import Documents from "./pages/Documents"

const provider = ""
// API key: keyRICOfYlRaLgFzw

// Componente para hacer scroll automáticamente hacía arriba en cada página
const ScrollToTop = ({ children, location }) => {
  React.useEffect(() => window.scrollTo(0, 0), [location.pathname])
  return children
}

const App = () => {
  const [pages, setPages] = useState([])
  const [projectName, setProjectName] = useState([])

  // Airtable API ->
  const retrieveTable = () => {
    let base = new Airtable({ apiKey: "keyRICOfYlRaLgFzw" }).base(
      "appLpc9Ewre2aXiiz"
    )

    base("Obras General")
      .select({
        view: "Grid view",
      })
      .eachPage(
        function page(records, fetchNextPage) {
          // This function (`page`) will get called for each page of records.
          records.forEach(function (record) {
            setPages(elem => [...elem, record.get("No.")])
            setProjectName(elem => [...elem, record.get("OBRA")])
          })
          // To fetch the next page of records, call `fetchNextPage`.
          // If there are more records, `page` will get called again.
          // If there are no more records, `done` will get called.
          fetchNextPage()
        },
        function done(err) {
          if (err) {
            console.error(err)
            return
          }
        }
      )
  }

  useEffect(() => {
    retrieveTable()
  }, [])

  return (
    <>
      <Router primary={false}>
        <ScrollToTop path="/">
          <Login path="/" />
          <Home path={`kila-home-id-980615`} />
          {/* Generador de páginas (perfiles y notas) */}
          {pages.map((elem, id) => (
            <Profile
              project={projectName[id]}
              page={elem}
              key={id}
              path={`/building/${elem}`}
            />
          ))}
          {pages.map((elem, id) => (
            <Compliance
              project={projectName[id]}
              page={elem}
              key={id}
              path={`/building/${elem}/compliance-notes`}
            />
          ))}
          {pages.map((elem, id) => (
            <NonCompliance
              project={projectName[id]}
              page={elem}
              key={id}
              path={`/building/${elem}/incompliance-notes`}
            />
          ))}
          {pages.map((elem, id) => (
            <Documents
              key={id}
              project={projectName[id]}
              page={elem}
              path={`/${elem}/documents`}
            />
          ))}
        </ScrollToTop>
      </Router>
    </>
  )
}

export default App
